import { ContentCollectionsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useCollectionsAPI(): ContentCollectionsApi {
  return new ContentCollectionsApi(apiConfig);
}
